<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form filter-block"
            size="mini"
        >
            <el-form-item label="客户搜索词:" class="query-form-item">
                <el-input
                    v-model="query.keyword"
                    placeholder="请输入客户搜索词"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                >查询
                </el-button
                >
                <el-button @click="import_file" type="success" size="mini">导入数据</el-button>
                <el-button @click="download_file" type="success" size="mini">导出数据</el-button>
                <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini" @click.native="onDelete()">批量删除
                </el-button>
                <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini" @click.native="onDeleteAll()">全部删除
                </el-button>
            </el-form-item>
        </el-form>

        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;">
            <el-table-column
                type="selection"
                width="40"
                align="center">
            </el-table-column>
            <el-table-column
                label="id"
                width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="ASIN"
                width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="客户搜索词"
                width="600"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.keyword}}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="操作"
                width="300">
                <template slot-scope="scope">
                    <div @click.stop>
                        <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click.native="on_file_upload(scope.row, '上传词根数据')">上传词根</el-button>
                        <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click.native="on_file_upload(scope.row, '上传否认词根数据')">上传否认词根</el-button>
                        <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click.native="on_file_upload(scope.row, '上传已打广告词数据')">上传已打广告词</el-button>
                        <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click.native="on_file_upload(scope.row, '上传无效词数据')">上传无效词</el-button>
                        <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click.native="on_file_upload(scope.row, '上传种子词库数据')">上传种子词库</el-button>
                    </div>
                </template>
            </el-table-column> -->
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: left;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next">
        </el-pagination>
        <import-data ref="importDataModal" @close-callback="closeCllback"></import-data>

    </div>
</template>

<script>
    import * as api from '@/api/Product/Product.js'
    import {downloadFileUrl} from '@/utils/method'
    import importData from './importData'

    export default {
        components: {importData},

        data() {
            return {
                query: {
                    page: 1,
                    limit: 20,
                    asin: null,
                    state: null,
                },
                list: [],
                multipleSelection: [],
                disabled: false,
                loading: false
            }
        },
        methods: {
            closeCllback(isshow) {
                this.$refs.importDataModal.visible = false
                isshow == true && this.getList()
            },
            import_file() {
                this.$refs.importDataModal.functionStr = 'core_word_import'
                this.$refs.importDataModal.fileTxt = '上传核心词根数据模板.xlsx'
                this.$refs.importDataModal.tipTxt = '上传核心词根数据模板'
                this.$refs.importDataModal.title = '导入核心词根数据'
                this.$refs.importDataModal.state = this.query.state
                this.$refs.importDataModal.asin = this.query.asin
                this.$refs.importDataModal.visible = true
            },
            getList(asin, state) {
                this.query.asin = asin || this.query.asin
                this.query.state = state || this.query.state
                this.loading = true
                api.seed_word_core_word_list(this.query)
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.list = res.data.list
                            this.query.total = res.data.total
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            onDelete() {
                if (this.multipleSelection.length == 0) {
                    return this.$message({
                        type: 'error',
                        message: '请勾选需要删除的核心词根！'
                    })
                }
                this.$confirm(
                    `确定要删除 ${this.query.asin} 下的 ${
                        this.multipleSelection.length
                    } 个核心词根吗？`,
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                )
                    .then(() => {
                        this.loading = true
                        api.seed_word_core_word_delete({
                            ids: this.multipleSelection,
                            all_deleted: 0,
                            asin: this.query.asin,
                            state: this.query.state,
                        })
                            .then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    })
                                    this.getList()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                            })
                    })
                    .catch(() => {
                    })
            },
            onDeleteAll() {
                this.$confirm(`确定要删除全部核心词根吗？`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.loading = true
                        api.seed_word_core_word_delete({
                            ids: this.multipleSelection,
                            all_deleted: 1,
                            asin: this.query.asin,
                            state: this.query.state,
                        })
                            .then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({
                                        message: '全部删除成功',
                                        type: 'success'
                                    })
                                    this.getList()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                            })
                    })
                    .catch(() => {
                    })
            },
            //多选框
            handleSelectionChange(val) {
                let arr = []
                val.map(v => {
                    arr.push(v.id)
                })
                this.multipleSelection = arr
            },
            download_file() {
                api.seed_word_core_word_export({
                    asin: this.query.asin,
                    state: this.query.state,
                }).then((res) => {
                    if (res.success) {
                        downloadFileUrl(res.data)
                    }
                })
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .filter-block {
        background-color: #a9c7ff;
        padding: 6px 6px 6px 10px;
        font-size: 18px;
        color: #333;
        margin: 0;
        display: flex;
        align-items: center;
    }

    /deep/ .warningred {
        background: rgb(243, 107, 107) !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 0 !important;
    }
</style>
